<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="mini" style="width: 200px;" class="filter-item"
          :placeholder="'名称'" v-model="listQuery.key"> </el-input>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <permission-btn size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table style="height:calc(100% - 60px)" ref="mainTable" :select-type="'checkbox'"
          :table-fields="headerList" :data="list" :v-loading="listLoading" @row-click="rowClick"
          @selection-change="handleSelectionChange"></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange" />
      </div>
      <el-dialog v-el-drag-dialog class="dialog-mini" width="500px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible">
        <el-alert
          v-if="currentProfile && currentProfile.type === 2"
          type="warning"
          :closable="false"
          show-icon
          style="margin-bottom: 10px;"
          title="翻译模式为单轮对话，每轮结束后释放连接；切换到翻译模式会清空该账号当前的聊天上下文。"
        ></el-alert>
        <auth-form ref="dataForm" :rules="rules" :edit-model="true" :form-fields="headerList" v-model="temp"
          :col-num="1"></auth-form>        <div slot="footer">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="mini" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as tlAccounts from '@/api/tlAccounts'
import * as realtimeProfiles from '@/api/realtimePromptProfiles'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthForm from '../../components/Base/AuthForm.vue'
import AuthTable from '../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
export default {
  name: 'tlAccount',
  components: { Sticky, permissionBtn, Pagination, AuthTable, AuthForm, },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        key: undefined,
      },
      temp: {},
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
      },
      // 实时语音：提示词配置候选，以及当前所选配置的音色/语言候选
      profileList: [],
      currentProfile: null,
    }
  },
  watch: {
    // 提示词配置变化时重建表单项：音色候选随配置变化，聊天类型不显示目标语言
    'temp.promptProfileId': function (value) {
      this.applyProfile(value)
    },
  },
  created() {
    let voices = [{ label: '灿灿 2.0', value: 'BV700_V2_streaming' },
    { label: '炀炀', value: 'BV705_streaming   ' },
    { label: '擎苍 2.0', value: 'BV701_V2_streaming' },
    { label: '通用女声 2.0', value: 'BV001_V2_streaming' },
    { label: '灿灿', value: 'BV700_streaming   ' },
    { label: '超自然音色-梓梓2.0', value: 'BV406_V2_streaming' },
    { label: '超自然音色-梓梓', value: 'BV406_streaming' },
    { label: '超自然音色-燃燃2.0', value: 'BV407_V2_streaming' },
    { label: '超自然音色-燃燃', value: 'BV407_streaming' },
    { label: '通用女声', value: 'BV001_streaming' },
    { label: '通用男声', value: 'BV002_streaming' }];
    this.headerList = [
      new ColumnDefine('id', '', false, false, '', '', 'long', 'bigint', 'Id'),
      new ColumnDefine('uid', 'UID', true, true, '', '', 'string', 'varchar', 'Uid'),
      new ColumnDefine('account', '对讲账号', true, true, '', '', 'string', 'varchar', 'Account'),
      new ColumnDefine('aiEnabled', '是否启用AI', true, true, 'switch', '', 'bool', 'bit', 'AiEnabled'),
      new ColumnDefine('contextCount', '上下文轮次', true, true, '', '', 'int', 'int', 'ContextCount'),
      new ColumnDefine('modelConfigId', '模型配置Id', true, true, 'select', [{ value: 'QWen', label: '千问' }, { value: 'Doubao', label: '豆包火山大模型' }], 'string', 'varchar', 'ModelConfigId'),
      new ColumnDefine('ttsVoice', 'TTS音色', true, true, 'select', [...voices], 'string', 'varchar', 'TTSVoice'),

    ]
    // 实时语音相关表单项由 rebuildHeaderList 动态追加（依赖所选提示词配置）
    this.baseHeaderList = [...this.headerList]
    this.loadProfiles()
    this.getList()
  },
  methods: {
    // 加载启用中的提示词配置，作为账号的候选集来源
    loadProfiles() {
      realtimeProfiles
        .selectable()
        .then((res) => {
          this.profileList = res.result || []
          this.applyProfile(this.temp.promptProfileId)
          // 配置晚于列表返回时，补一次名称映射
          if (this.list && this.list.length > 0) {
            this.list = this.decorateRows(this.list)
          }
        })
        .catch(() => {
          this.profileList = []
          this.rebuildHeaderList()
        })
    },
    // 所选配置变化：刷新音色/语言候选，并清理已失效的选择
    applyProfile(profileId) {
      const profile = this.profileList.find((item) => item.id === profileId) || null
      this.currentProfile = profile

      const voices = (profile && profile.voices) || []
      const matchedVoice = voices.some((item) => item.key === this.temp.qWenRealtimeVoice)
      if (!matchedVoice) {
        this.temp.qWenRealtimeVoice = profile
          ? profile.defaultVoice || (voices[0] ? voices[0].key : '')
          : ''
      }

      const languages = (profile && profile.languages) || []
      const isTranslate = !!profile && profile.type === 2
      if (!isTranslate) {
        // 聊天类型不保留目标语言，避免模式切换后残留旧值
        this.temp.targetLanguage = ''
      } else if (!languages.some((item) => item.key === this.temp.targetLanguage)) {
        this.temp.targetLanguage = languages[0] ? languages[0].key : ''
      }

      this.rebuildHeaderList()
    },
    // 重建表单项：实时语音三项依赖所选配置，不能写死在初始列表里
    rebuildHeaderList() {
      const profileOptions = this.profileList.map((item) => ({
        value: item.id,
        label: `${item.name}（${item.type === 2 ? '翻译' : '聊天'}）`,
      }))
      const voiceOptions = ((this.currentProfile && this.currentProfile.voices) || []).map((item) => ({
        value: item.key,
        label: item.name,
      }))

      const list = [
        ...this.baseHeaderList,
        new ColumnDefine('promptProfileId', '提示词配置', true, false, 'select', profileOptions, 'long', 'bigint', 'PromptProfileId'),
        new ColumnDefine('qWenRealtimeVoice', '实时音色', true, false, 'select', voiceOptions, 'string', 'varchar', 'QWenRealtimeVoice'),
      ]

      if (this.currentProfile && this.currentProfile.type === 2) {
        const languageOptions = (this.currentProfile.languages || []).map((item) => ({
          value: item.key,
          label: item.name,
        }))
        list.push(
          new ColumnDefine('targetLanguage', '目标语言', true, false, 'select', languageOptions, 'string', 'varchar', 'TargetLanguage')
        )
      }

      // 列表只展示可读名称，避免把配置 Id 与音色 key 直接暴露在表格里
      list.push(new ColumnDefine('profileName', '提示词配置', false, true, '', '', 'string', 'varchar', 'ProfileName'))
      list.push(new ColumnDefine('voiceName', '实时音色', false, true, '', '', 'string', 'varchar', 'VoiceName'))

      this.headerList = list
    },
    // 提交前归一化：未选配置时 id 必须是 null，否则后端会当成"配置不存在"
    normalizeTemp(data) {
      const result = Object.assign({}, data)
      // 列表展示用的派生字段不提交
      delete result.profileName
      delete result.voiceName
      if (!result.promptProfileId) {
        result.promptProfileId = null
        result.qWenRealtimeVoice = ''
        result.targetLanguage = ''
      }
      if (!result.targetLanguage) {
        result.targetLanguage = ''
      }
      return result
    },

    rowClick(row) {
      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onBtnClicked: function (domId, callback) {
      console.log('you click:' + domId)
      switch (domId) {
        case 'btnAdd':
          this.handleCreate()
          break
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          this.handleUpdate(this.multipleSelection[0])
          break
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error',
            })
            return
          }
          this.handleDelete(this.multipleSelection)
          break
        case 'btnExport':
          this.$refs.mainTable.exportExcel('资源文件', callback)
          break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      tlAccounts.getList(this.listQuery).then((response) => {
        this.list = this.decorateRows(response.data || [])
        this.total = response.count
        this.listLoading = false
      })
    },
    // 把配置 Id 与音色 key 映射为可读名称
    decorateRows(rows) {
      const profileNameMap = {}
      const voiceNameMap = {}
      this.profileList.forEach((profile) => {
        profileNameMap[profile.id] = profile.name
        const voices = profile.voices || []
        voices.forEach((voice) => {
          voiceNameMap[voice.key] = voice.name
        })
      })

      return rows.map((row) => {
        const item = Object.assign({}, row)
        item.profileName = item.promptProfileId
          ? profileNameMap[item.promptProfileId] || `#${item.promptProfileId}`
          : '全局默认'
        item.voiceName = voiceNameMap[item.qWenRealtimeVoice] || item.qWenRealtimeVoice || '-'
        return item
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
        console.log(`${item.columnName},${item.entityType},${obj[item.columnName]}`);
      })
      this.temp = Object.assign({}, obj) // copy obj
    },
    handleCreate() {
      // 弹出添加框
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      // 保存提交
      this.$refs['dataForm'].validate(() => {
        tlAccounts.add(this.normalizeTemp(this.temp)).then(() => {
          this.list.unshift(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleUpdate(row) {
      // 弹出编辑框
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      // 更新提交
      this.$refs['dataForm'].validate(() => {
        const tempData = this.normalizeTemp(this.temp)
        tlAccounts.update(tempData).then(() => {
          for (const v of this.list) {
            if (v.id === this.temp.id) {
              const index = this.list.indexOf(v)
              this.list.splice(index, 1, this.temp)
              break
            }
          }
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleDelete(rows) {
      // 多行删除
      this.delrows(tlAccounts, rows)
    },
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
